// Shared across the Guide → Support tab and the Ally support bot dock, so
// there's exactly one place to update if these ever change.
export const SUPPORT_EMAIL = "info@globalcyberassociate.com";
export const SUPPORT_WHATSAPP = "918939851788";
